import { Box } from "@mui/system";
import FraudPlayersFilter from "./FraudPlayersFilter";
import FraudPlayersItem from "./FraudPlayersItem";

const FraudPlayers = () => {
  return (
    <>
      <Box sx={{ px: 2 }}>
        <FraudPlayersFilter />
        <FraudPlayersItem/>
      </Box>
    </>
  );
};

export default FraudPlayers;
